// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The session context dialogs token.
 */
export const ISessionContextDialogs = new Token('@jupyterlab/apputils:ISessionContextDialogs');
/* tslint:enable */
/* tslint:disable */
/**
 * The theme manager token.
 */
export const IThemeManager = new Token('@jupyterlab/apputils:IThemeManager');
/**
 * The sanitizer token.
 */
export const ISanitizer = new Token('@jupyterlab/apputils:ISanitizer');
/**
 * The toolbar registry token.
 */
export const IToolbarWidgetRegistry = new Token('@jupyterlab/apputils:IToolbarWidgetRegistry');
//# sourceMappingURL=tokens.js.map